import React, { PureComponent } from 'react'
import './index.css'

class Helper extends PureComponent {
  render() {
    const { children, show } = this.props

    if (!show) {
      return null
    }

    return (
      <div className={ 'helper' }>
        { children }
      </div>
    )
  }
}

export default Helper



// WEBPACK FOOTER //
// ./src/components/Helper/index.js